import React from 'react';
import PropTypes from 'prop-types';
import {
  InputText,
  Radio,
  Textarea,
} from '@othermachines/react-form-kit';

import {
  Fieldset,
} from '../../../Shared';

import {
  FileSizeError,
  inputTheme,
  inputThemeShort,
  radioTheme,
  textareaTheme,
} from '../../../lib';
import { Input } from 'postcss';


const formName = 'Stamp Accessories';

const defaultValues = {
  'Ink-bottles-quantity': '',
  'Ink-bottles-colour': '',
  'Stamp-pads-quantity': '',
  'Stamp-pads-size': '',
  'Stamp-pads-colour': '',
  'Trodat-quantity': '',
  'Trodat-size': '',
  'Trodat-colour': '',
  'Hi-seal-ink-quanity': '',
  'Hi-seal-ink-colour': '',
  'Hi-seal-ink-pad-quantity': '',
  'Oversized-in-pad-quantity': '',
};

const fields = [
  'Ink-bottles-quantity',
  'Ink-bottles-colour',
  'Stamp-pads-quantity',
  'Stamp-pads-size',
  'Stamp-pads-colour',
  'Trodat-quantity',
  'Trodat-size',
  'Trodat-colour',
  'Hi-seal-ink-quanity',
  'Hi-seal-ink-colour',
  'Hi-seal-pad-quantity',
  'Oversized-dry-pad-quantity',
];

const Component = ({
  submitForm: {
    control,
    formState,
    register,
    setValue,
    unregister,
    watch,
  },

}) => {

  return (
    <>
      <Fieldset legend="Replacement ink bottles">

        <InputText
          inputTextId='Ink-bottles-quantity'
          inputTextName='Ink-bottles-quantity'
          register={register}
          formState={formState}
          label='Quantity'
          theme={inputThemeShort}
        />

        <InputText
          inputTextId='Ink-bottles-colour'
          inputTextName='Ink-bottles-colour'
          register={register}
          formState={formState}
          label='Ink bottle colour'
          theme={inputTheme}
        />

      </Fieldset>

      <Fieldset legend="Replacement stamp pads">

        <InputText
          inputTextId='Stamp-pads-quantity'
          inputTextName='Stamp-pads-quantity'
          register={register}
          formState={formState}
          label='Quantity'
          theme={inputThemeShort}
        />

        <InputText
          inputTextId='Stamp-pads-size'
          inputTextName='Stamp-pads-size'
          register={register}
          formState={formState}
          label='Size'
          theme={inputTheme}
        />

        <InputText
          inputTextId='Stamp-pads-colour'
          inputTextName='Stamp-pads-colour'
          register={register}
          formState={formState}
          label='Colour'
          theme={inputTheme}
        />

      </Fieldset>

      <Fieldset legend="Replacement Trodat pads">

        <InputText
          inputTextId='Trodat-quantity'
          inputTextName='Trodat-quantity'
          register={register}
          formState={formState}
          label='Quantity'
          theme={inputThemeShort}
        />
        <InputText
          inputTextId='Trodat-size'
          inputTextName='Trodat-size'
          register={register}
          formState={formState}
          label='Size'
          theme={inputTheme}
        />
        <InputText
          inputTextId='Trodat-colour'
          inputTextName='Trodat-colour'
          register={register}
          formState={formState}
          label='Colour'
          theme={inputTheme}
        />

      </Fieldset>

      <Fieldset legend="Replacement Hi-Seal ink">

        <InputText
          inputTextId='Hi-seal-ink-quanity'
          inputTextName='Hi-seal-ink-quanity'
          register={register}
          formState={formState}
          label='Quantity'
          theme={inputThemeShort}
        />
        <InputText
          inputTextId='Hi-seal-ink-colour'
          inputTextName='Hi-seal-ink-colour'
          register={register}
          formState={formState}
          label='Colour'
          theme={inputTheme}
        />

      </Fieldset>

      <Fieldset legend="Replacement Hi-Seal ink pads">
          
          <InputText
            inputTextId='Hi-seal-ink-pad-quantity'
            inputTextName='Hi-seal-ink-pad-quantity'
            register={register}
            formState={formState}
            label='Quantity'
            theme={inputThemeShort}
          />

        </Fieldset>

        <Fieldset legend='Replacement oversized dry ink pads (7" x 11")'>
          <InputText
            inputTextId='Oversized-dry-pad-quantity'
            inputTextName='Oversized-dry-pad-quantity'
            register={register}
            formState={formState}
            label='Quantity'
            theme={inputThemeShort}
          />
        </Fieldset>
    </>
  );
};

Component.propTypes = {
  submitForm: PropTypes.shape({
    control: PropTypes.object.isRequired,
    formState: PropTypes.object.isRequired,
    register: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    unregister: PropTypes.func.isRequired,
    watch: PropTypes.func.isRequired,
  }).isRequired,
};

export default Component;
export { defaultValues, fields, formName };

